import React from 'react';
import AdminListingPage from '../components/admin/AdminListingPage';

const AdminPropertyListings = () => {
  return (
    <AdminListingPage
      listingType="property"
      heading="Property Listing"
      subtitle="Separate page for MLS-style property listing entries."
    />
  );
};

export default AdminPropertyListings;
